import { Outlet } from 'react-router-dom';
import { DashboardSidebar } from '@/components/dashboard/DashboardSidebar';
import { ScrollArea } from '@/components/ui/scroll-area';
import { cn } from '@/lib/utils';

export function DashboardLayout() {
  return (
    <div className="bg-sidebar flex flex-1 overflow-hidden">
      <aside className="bg-sidebar shrink-0">
        <DashboardSidebar />
      </aside>
      <main className="relative flex flex-1 overflow-hidden">
        <div className={cn('flex-1 overflow-hidden border-l')}>
          <ScrollArea className="h-full">
            <Outlet />
          </ScrollArea>
        </div>
      </main>
    </div>
  );
}
